import { render, staticRenderFns } from "./TraxTrainingCompetencyIndexCrudSearch.vue?vue&type=template&id=1a580010"
import script from "./TraxTrainingCompetencyIndexCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyIndexCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports